import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./common/ProtectedRoute"; 
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

import UserAccounts from "./scenes/useraccounts";
import Subscriptions from "./scenes/subscriptions";

import Landing from "./pages/landing";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Reset from "./pages/reset";
import Signup from "./pages/signup";
import ContactUs from "./pages/contactus";
import Subscribe from "./pages/subscribe";
import Pricing from "./pages/pricing";
import CheckoutSuccess from "./pages/subscribe/steps/checkoutsuccess";
import CheckoutCancelled from "./pages/subscribe/steps/checkoutcancel";
import CheckoutSuccessDodo from "./pages/subscribe/steps/checkoutsuccessdodo";
import CheckoutCancelledDodo from "./pages/subscribe/steps/checkoutcanceldodo";

import ConfirmMarketingOptIn from "./pages/confirmmarketingoptin";

import PaidMarketingLandingPage from "./pages/paidmarketinglandingpage";

import PaidMarketingLandingPageReddit from "./pages/paidmarketinglandingpagereddit";

import  OptOutOfMarketingEmails from "./pages/optoutmarketingemails";

import  OptOutOfPPCMarketingEmails from "./pages/optoutppcmarketingemails";

import  DemoPage from "./pages/demopage";

import TermsOfService from "./pages/termsofservice";

import Dashboard from "./scenes/dashboard";

import Unauthorized from "./scenes/unauthorized";

import NotFound from "./pages/pagenotfound";

import ServiceCategories from "./scenes/servicecategories";
import Customers from "./scenes/customers";
import Staff from "./scenes/staff";
import TailoringServices from "./scenes/tailoringservices";
import Suppliers from "./scenes/suppliers";
import Customizations from "./scenes/customizations";
import CustomizationsByType from "./scenes/customizations/indexByType";
import Garments from "./scenes/garments";
import Orders from "./scenes/orders";
import OrdersByOrderStatus from "./scenes/orders/indexByOrderStatus";
import OrdersByPaymentStatus from "./scenes/orders/indexByPaymentStatus";
import OrdersByPaymentMethod from "./scenes/orders/indexByPaymentMethod";
import CustomerFeedback from "./scenes/customerfeedback";
import CustomerFeedbackByResolutionStatus from "./scenes/customerfeedback/indexByResolutionStatus";
import TailorPerformance from "./scenes/tailorperformance";
import Appointments from "./scenes/appointments";
import AppointmentsByPaymentStatus from "./scenes/appointments/indexByPaymentStatus";
import AppointmentsByAppointmentType from "./scenes/appointments/indexByAppointmentType";
import Payments from "./scenes/payments";
import PaymentsByStatus from "./scenes/payments/indexByStatus";
import PaymentsByCurrency from "./scenes/payments/indexByCurrency";
import PaymentsByBillingCycle from "./scenes/payments/indexByBillingCycle";
import PaymentsByRefundStatus from "./scenes/payments/indexByRefundStatus";
import ProductionSchedule from "./scenes/productionschedule";
import Fabrics from "./scenes/fabrics";
import FabricsByType from "./scenes/fabrics/indexByType";
import InventoryManagement from "./scenes/inventorymanagement";
import Measurements from "./scenes/measurements";
import MeasurementsByFit from "./scenes/measurements/indexByFit";
import MeasurementsByClothingType from "./scenes/measurements/indexByClothingType";
import MeasurementsByGarmentType from "./scenes/measurements/indexByGarmentType";
import MeasurementsByUseTemplate from "./scenes/measurements/indexByUseTemplate";


import ToastMessageDisplay from "./common/ToastMessageDisplay"; 
import { UserProvider } from "./common/UserContext";
import { ApplicationModeProvider } from "./common/ApplicationModeContext";
import { UserCountProvider } from "./common/UserCountContext";
import { AccountProvider } from "./common/AccountContext";

import Bar from "./scenes/bar";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import { Navigate } from "react-router-dom";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");  // Add this line to hold the search term
  const location = useLocation();

  const publicPaths = ["/", 
    "/index.html", 
    "/login", 
    "/logout", 
    "/reset", 
    "/signup",
    "/contactus", 
    "/subscribe", 
    "/pricing", 
    "/terms-of-service", 
    "/confirm-marketing-opt-in",
    "/opt-out-of-marketing-emails",
    "/opt-out-of-ppc-marketing-emails",
    "/checkout-success", 
    "/checkout-cancelled",
    "/checkout-dodo-success", 
    "/checkout-dodo-cancelled",

    "/not-found",
    "/limited-time-discount-offer",
    "/demo",
    "/i-built-a-tool"];

  const isPublic = publicPaths.includes(location.pathname);

/************************************ PUBLIC PAGES ********************************************* */

if (isPublic) {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/index.html" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/confirm-marketing-opt-in" element={<ConfirmMarketingOptIn />} />
      <Route path="/opt-out-of-marketing-emails" element={<OptOutOfMarketingEmails />} />
      <Route path="/opt-out-of-ppc-marketing-emails" element={<OptOutOfPPCMarketingEmails />} />
      <Route path="/limited-time-discount-offer" element={<PaidMarketingLandingPage />} />
      <Route path="/i-built-a-tool" element={<PaidMarketingLandingPageReddit />} />
      <Route path="/demo" element={<DemoPage />} />

      <Route path="/checkout-success" element={<CheckoutSuccess />} />
      <Route path="/checkout-cancelled" element={<CheckoutCancelled />} />
      <Route path="/checkout-dodo-success" element={<CheckoutSuccessDodo />} />
      <Route path="/checkout-dodo-cancelled" element={<CheckoutCancelledDodo />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/************************************ PRIVATE PAGES ********************************************* */

  return (
    <ApplicationModeProvider>  
      <UserProvider>
        <UserCountProvider>
          <AccountProvider>
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div className="app">
                  <Sidebar isSidebar={isSidebar} />
                  <main className="content">
                    <Topbar setIsSidebar={setIsSidebar} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                    <Routes>
                      <Route path="/app" element={<ProtectedRoute element={<Dashboard />} />} />

                      <Route path="/servicecategories" element={<ProtectedRoute element={<ServiceCategories searchTerm={searchTerm} />} />} />
<Route path="/customers" element={<ProtectedRoute element={<Customers searchTerm={searchTerm} />} />} />
<Route path="/staff" element={<ProtectedRoute element={<Staff searchTerm={searchTerm} />} />} />
<Route path="/tailoringservices" element={<ProtectedRoute element={<TailoringServices searchTerm={searchTerm} />} />} />
<Route path="/suppliers" element={<ProtectedRoute element={<Suppliers searchTerm={searchTerm} />} />} />
<Route path="/customizations" element={<ProtectedRoute element={<Customizations searchTerm={searchTerm} />} />} />
<Route path="/customizations/list" element={<ProtectedRoute element={<Customizations searchTerm={searchTerm} />} />} />
<Route path="/customizations/type" element={<ProtectedRoute element={<CustomizationsByType searchTerm={searchTerm} />} />} />
<Route path="/garments" element={<ProtectedRoute element={<Garments searchTerm={searchTerm} />} />} />
<Route path="/garments/list" element={<ProtectedRoute element={<Garments searchTerm={searchTerm} />} />} />
<Route path="/orders" element={<ProtectedRoute element={<Orders searchTerm={searchTerm} />} />} />
<Route path="/orders/list" element={<ProtectedRoute element={<Orders searchTerm={searchTerm} />} />} />
<Route path="/orders/orderstatus" element={<ProtectedRoute element={<OrdersByOrderStatus searchTerm={searchTerm} />} />} />
<Route path="/orders/paymentstatus" element={<ProtectedRoute element={<OrdersByPaymentStatus searchTerm={searchTerm} />} />} />
<Route path="/orders/paymentmethod" element={<ProtectedRoute element={<OrdersByPaymentMethod searchTerm={searchTerm} />} />} />
<Route path="/customerfeedback" element={<ProtectedRoute element={<CustomerFeedback searchTerm={searchTerm} />} />} />
<Route path="/customerfeedback/list" element={<ProtectedRoute element={<CustomerFeedback searchTerm={searchTerm} />} />} />
<Route path="/customerfeedback/resolutionstatus" element={<ProtectedRoute element={<CustomerFeedbackByResolutionStatus searchTerm={searchTerm} />} />} />
<Route path="/tailorperformance" element={<ProtectedRoute element={<TailorPerformance searchTerm={searchTerm} />} />} />
<Route path="/tailorperformance/list" element={<ProtectedRoute element={<TailorPerformance searchTerm={searchTerm} />} />} />
<Route path="/appointments" element={<ProtectedRoute element={<Appointments searchTerm={searchTerm} />} />} />
<Route path="/appointments/list" element={<ProtectedRoute element={<Appointments searchTerm={searchTerm} />} />} />
<Route path="/appointments/paymentstatus" element={<ProtectedRoute element={<AppointmentsByPaymentStatus searchTerm={searchTerm} />} />} />
<Route path="/appointments/appointmenttype" element={<ProtectedRoute element={<AppointmentsByAppointmentType searchTerm={searchTerm} />} />} />
<Route path="/payments" element={<ProtectedRoute element={<Payments searchTerm={searchTerm} />} />} />
<Route path="/payments/list" element={<ProtectedRoute element={<Payments searchTerm={searchTerm} />} />} />
<Route path="/payments/status" element={<ProtectedRoute element={<PaymentsByStatus searchTerm={searchTerm} />} />} />
<Route path="/payments/currency" element={<ProtectedRoute element={<PaymentsByCurrency searchTerm={searchTerm} />} />} />
<Route path="/payments/billingcycle" element={<ProtectedRoute element={<PaymentsByBillingCycle searchTerm={searchTerm} />} />} />
<Route path="/payments/refundstatus" element={<ProtectedRoute element={<PaymentsByRefundStatus searchTerm={searchTerm} />} />} />
<Route path="/productionschedule" element={<ProtectedRoute element={<ProductionSchedule searchTerm={searchTerm} />} />} />
<Route path="/productionschedule/list" element={<ProtectedRoute element={<ProductionSchedule searchTerm={searchTerm} />} />} />
<Route path="/fabrics" element={<ProtectedRoute element={<Fabrics searchTerm={searchTerm} />} />} />
<Route path="/fabrics/list" element={<ProtectedRoute element={<Fabrics searchTerm={searchTerm} />} />} />
<Route path="/fabrics/type" element={<ProtectedRoute element={<FabricsByType searchTerm={searchTerm} />} />} />
<Route path="/inventorymanagement" element={<ProtectedRoute element={<InventoryManagement searchTerm={searchTerm} />} />} />
<Route path="/inventorymanagement/list" element={<ProtectedRoute element={<InventoryManagement searchTerm={searchTerm} />} />} />
<Route path="/measurements" element={<ProtectedRoute element={<Measurements searchTerm={searchTerm} />} />} />
<Route path="/measurements/list" element={<ProtectedRoute element={<Measurements searchTerm={searchTerm} />} />} />
<Route path="/measurements/fit" element={<ProtectedRoute element={<MeasurementsByFit searchTerm={searchTerm} />} />} />
<Route path="/measurements/clothingtype" element={<ProtectedRoute element={<MeasurementsByClothingType searchTerm={searchTerm} />} />} />
<Route path="/measurements/garmenttype" element={<ProtectedRoute element={<MeasurementsByGarmentType searchTerm={searchTerm} />} />} />
<Route path="/measurements/usetemplate" element={<ProtectedRoute element={<MeasurementsByUseTemplate searchTerm={searchTerm} />} />} />


                      <Route path="/pie" element={<ProtectedRoute element={<Pie />} />} />
                      <Route path="/line" element={<ProtectedRoute element={<Line />} />} />
                      <Route path="/calendar" element={<ProtectedRoute element={<Calendar />} />} />
                      <Route path="/geography" element={<ProtectedRoute element={<Geography />} />} />

                      <Route path="/useraccounts" element={<ProtectedRoute element={<UserAccounts />} role="admin" />} />
                      <Route path="/subscriptions" element={<ProtectedRoute element={<Subscriptions />} role="admin" />} />

                      <Route path="/unauthorized" element={<ProtectedRoute element={<Unauthorized />} />} />

                      <Route path="*" element={<Navigate to="/not-found" replace />} />

                    </Routes>
                    <ToastMessageDisplay />
                  </main>
                </div>
              </ThemeProvider>
            </ColorModeContext.Provider>
            </AccountProvider>
        </UserCountProvider>
      </UserProvider>
    </ApplicationModeProvider>
  );
}

export default App;
